<template>
    <div id="landing">
        <!-- h1>Welcome, {{ this.$store.getters.getUser.username }}!</h1 -->
        <div class="condtainer">
            <div
                class="dblanding"
                v-if="this.$store.getters.isStaffMode && this.$store.getters.hasAdminPerms(this.$store.getters.staffGuild)"
            >
                <div class="welcomebox">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-xl-8 col-lg-7">
                                <h2 class="display-3 pt-4 pb-1">
                                    <small class="d-block">Staff Mode for:</small>
                                    {{
                                        $store.getters.staffGuilds.find(guild => guild.guild_id == $store.getters.staffGuild).name
                                    }}
                                </h2>
                                <router-link
                                    v-if="
                                        this.$store.getters.isStaffMode &&
                                            this.$store.getters.hasAdminPerms(this.$store.getters.staffGuild)
                                    "
                                    to="/settings"
                                    class="btn btn-primary btnopenSettings px-3"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-settings mr-1"
                                    >
                                        <circle cx="12" cy="12" r="3"></circle>
                                        <path
                                            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                                        ></path>
                                    </svg>
                                    Settings
                                </router-link>
                                <button @click="exitStaffMode()" class="btn btn-secondary btnopenSettings px-3">
                                    Exit Staff Mode
                                </button>

                                <nav aria-label="breadcrumb" role="navigation">
                                    <ol class="breadcrumb text-center">
                                        <li class="breadcrumb-item">
                                            <a href="https://docs.ticketbot.xyz/" target="_blank">Documentation</a>
                                        </li>
                                        <li class="breadcrumb-item">
                                            <a href="https://docs.ticketbot.xyz/commands/" target="_blank">Commands</a>
                                        </li>
                                        <li class="breadcrumb-item"><a href="https://ticketbot.xyz/invite" target="_blank">Get TicketBot</a></li>
                                        <li class="breadcrumb-item"><a href="https://ticketbot.xyz/discord" target="_blank">Get Support</a></li>
                                    </ol>
                                </nav>
                            </div>
                            <div class="col-12 col-xl-4 col-lg-5">
                                <div class="premiumbox pt-4">
                                    <div class="card">
                                        <div class="card-header">
                                            TicketBot Premium
                                        </div>
                                        <div class="card-body">
                                            <div v-if="hasPremium">
                                                <h5 class="card-title">Subscribed. {{ until() }} days left.</h5>
                                                <router-link to="/payment" class="btn btn-primary"
                                                    >Manage subscription</router-link
                                                >
                                            </div>
                                            <div v-else>
                                                <h5 class="card-title">No active subscription.</h5>
                                                <router-link to="/payment" class="btn btn-primary">Subscribe now!</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dividershape">
                    <svg viewBox="0 0 2880 48" class="dividersvg" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="#16191c"></path>
                    </svg>
                </div>

                <landingstats
                    v-if="this.$store.getters.isStaffMode && this.$store.getters.hasAdminPerms(this.$store.getters.staffGuild)"
                />
            </div>
            <div class="userpage" v-else>
                <div class="container">
                    <div class="row">
                        <div class="col-md-7">
                            <h3 class="mb-1">Welcome to TicketBot, {{ this.$store.getters.getUser.username }}!</h3>
                            <p>
                                In the sidebar menu on the left, you can see all your current and previous tickets that have been
                                made through TicketBot.
                            </p>
                            <p class="pt-4">
                                If you are a server admin and you are using TicketBot, you can enter "Staff Mode" by clicking the
                                button underneath the search bar.
                            </p>
                            <p class="pt-4 pb-3">
                                If you are not (yet) using TicketBot on your server, you can learn more about the bot and get it
                                on your server using the links below.
                            </p>
                            <a href="https://ticketbot.xyz" target="_blank" class="btn btn-primary btn-sm">Website</a>
                            <a href="https://ticketbot.xyz/discord" target="_blank" class="btn btn-primary btn-sm"
                                >Support Server</a
                            >
                            <a href="https://ticketbot.xyz/invite" target="_blank" class="btn btn-primary btn-sm"
                                >Get TicketBot</a
                            >
                        </div>
                        <div class="offset-md-1 col-md-3">
                            <img src="https://ticketbot.xyz/static/img/bot_logo.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import landingstats from '@/components/dashboard/landingstats'
import { EventBus } from '@/events/eventbus'
export default {
    name: 'landing',
    data() {
        return {
            premiumTime: 0,
        }
    },
    components: {
        landingstats,
    },

    created() {
        this.getPremiumTime()
        EventBus.$on('staffmode', guildId => this.getPremiumTime(guildId))
    },
    destroyed() {
        EventBus.$off('staffmode', guild => this.getPremiumTime())
    },
    methods: {
        until() {
            const delta = Math.abs(this.premiumTime - new Date().getTime()) / 1000
            return Math.floor(delta / 86400)
        },
        getPremiumTime(id = this.$store.getters.staffGuild) {
            this.$settings.getAllSettings(id).then(settings => {
                this.premiumTime = settings.premiumTime
            })
        },
        exitStaffMode() {
            this.$store.dispatch('toggleStaffMode')
            this.$forceUpdate()
        },
    },
    computed: {
        hasPremium() {
            return this.premiumTime > Date.now()
        },
    },
}
</script>

<style scoped>
#landing {
    /* padding: 30px; */
    margin-top: 66px;
}

#landing h1 {
    text-align: center;
}
.blockPanel {
    justify-content: center;
}
.rectangle {
    width: 90px;
    margin-right: 5px;
    margin-left: 5px;
    transition: all 0.2s ease-in-out;
    padding-bottom: 10px;
}
.rectangle .card:hover {
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.3);
}
#content {
    right: 0px !important;
    width: calc(100% - 300px) !important;
}
.ticketinfo {
    display: none;
}
.stats_disabled {
    cursor: pointer !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    opacity: 0.4;
    display: block;
}
.card {
    background: #212529;
}
.card .card-header {
    padding: 15px;
    border-bottom: 1px solid #1e2126;
}
.btnopenSettings {
    margin: 0 0 20px;
}
.btnopenSettings svg {
    margin-top: -4px;
    margin-bottom: -2px;
}
.userpage {
    margin: 0 auto;
    padding-top: 100px;
}
.userpage img {
    border-radius: 50%;
}
.dblanding .welcomebox {
    padding-top: 40px;
    padding-bottom: 70px;
    background-image: linear-gradient(to bottom, rgba(24, 75, 230, 0.52), rgba(0, 83, 255, 0.73));
    background-image: linear-gradient(rgb(18 20 23), rgb(18 20 23));
}
.dblanding h2.display-3 {
    font-weight: 300;
    color: #e14eca;
}
.dblanding h2.display-3 small {
    color: hsla(0, 0%, 100%, 0.8);
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 60%;
}
.dividershape {
    margin-top: -30px;
    max-width: 100%;
    overflow: hidden;
    padding-bottom: 10px;
}
.dividershape svg.dividersvg {
    transform: scale(2);
    transform-origin: top center;
}
.premiumbox {
    text-align: center;
}
.premiumbox .card {
    width: 100%;
}
.premiumbox .btn {
    padding: 11px 20px;
}
@media (min-width: 1200px) {
    .premiumbox .card {
        width: fit-content;
        margin-left: auto;
    }
}
.breadcrumb {
    justify-content: start;
    padding-left: 0px;
    background-color: transparent;
}
.breadcrumb-item + .breadcrumb-item:before {
    color: #24292d;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/landing.vue